import React from 'react';
import { trackEvent } from '../utils/analytics';

// Claimed Trustpilot profile for planettransfers.online (business unit 6a8c9db90fa83ca390531105).
// Plain links instead of the TrustBox script: no third-party cookies, nothing to consent to,
// and no "0 reviews" badge on show while the profile is still new.
export const TRUSTPILOT_PROFILE_URL = 'https://www.trustpilot.com/review/planettransfers.online';
export const TRUSTPILOT_REVIEW_URL = 'https://www.trustpilot.com/evaluate/planettransfers.online';

const TP_GREEN = '#00B67A';

export function TrustpilotStar({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path fill={TP_GREEN} d="M12 1.5l3.1 7.3 7.9.6-6 5.2 1.8 7.7L12 18.2l-6.8 4.1L7 14.6 1 9.4l7.9-.6z" />
    </svg>
  );
}

function FiveStars() {
  return (
    <span className="inline-flex gap-0.5" aria-hidden="true">
      {[0, 1, 2, 3, 4].map(i => (
        <span key={i} className="w-6 h-6 flex items-center justify-center" style={{ backgroundColor: TP_GREEN }}>
          <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#fff" d="M12 1.5l3.1 7.3 7.9.6-6 5.2 1.8 7.7L12 18.2l-6.8 4.1L7 14.6 1 9.4l7.9-.6z" /></svg>
        </span>
      ))}
    </span>
  );
}

// Card asking a customer who just booked to leave a review.
export function TrustpilotReviewCard({ placement }) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm text-center" data-testid="trustpilot-review-card">
      <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold mb-3">Happy with your booking?</p>
      <div className="flex justify-center mb-3"><FiveStars /></div>
      <p className="text-sm text-slate-600 mb-4 max-w-sm mx-auto">
        A short review on Trustpilot helps other travellers book with confidence. It only takes a minute.
      </p>
      <a
        href={TRUSTPILOT_REVIEW_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackEvent('trustpilot_review_click', { placement })}
        className="inline-flex items-center gap-2 text-white text-sm font-semibold px-5 py-2.5 rounded-lg hover:opacity-90 transition-opacity"
        style={{ backgroundColor: TP_GREEN }}
        data-testid="trustpilot-review-btn"
      >
        Review us on Trustpilot
      </a>
    </div>
  );
}

// Small link for footers.
export function TrustpilotLink({ className = '' }) {
  return (
    <a
      href={TRUSTPILOT_PROFILE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent('trustpilot_profile_click', { placement: 'footer' })}
      className={`inline-flex items-center gap-2 ${className}`}
      data-testid="trustpilot-footer-link"
    >
      <TrustpilotStar />
      <span>Trustpilot</span>
    </a>
  );
}
